import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ComponentsModule } from '@freelancer/components';
import {
  DatastoreBidsModule,
  DatastoreBillingAgreementsModule,
  DatastoreCurrenciesModule,
  DatastoreEncodedUrlModule,
  DatastoreMembershipBenefitsModule,
  DatastoreMilestonesModule,
  DatastoreProfileViewUsersModule,
  DatastoreProjectBudgetOptionsModule,
  DatastoreProjectsModule,
  DatastoreProjectViewProjectsModule,
  DatastoreProjectViewUsersModule,
  DatastoreUserBidOnRussianProjectsModule,
  DatastoreUserHasDuplicateIpModule,
  DatastoreUserRestrictionsModule,
  DatastoreUserRequiresPaymentVerificationModule,
  DatastoreUsersFollowModule,
  DatastoreUsersLocationModule,
  DatastoreUsersModule,
  DatastoreUsersRecommendModule,
} from '@freelancer/datastore/collections';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { HireMeModule } from 'app/hire-me/hire-me.module';
import { UserProfileContactModalHireMeFormComponent } from './user-profile-contact-modal-hire-me-form.component';
import { UserProfileContactModalOptionsComponent } from './user-profile-contact-modal-options.component';
import { UserProfileContactModalComponent } from './user-profile-contact-modal.component';
import { UserProfileRequestQuoteFormComponent } from './user-profile-request-quote-form.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    DatastoreBidsModule,
    DatastoreBillingAgreementsModule,
    DatastoreCurrenciesModule,
    DatastoreEncodedUrlModule,
    DatastoreMembershipBenefitsModule,
    DatastoreMilestonesModule,
    DatastoreProfileViewUsersModule,
    DatastoreProjectBudgetOptionsModule,
    DatastoreProjectsModule,
    DatastoreProjectViewProjectsModule,
    DatastoreProjectViewUsersModule,
    DatastoreUserBidOnRussianProjectsModule,
    DatastoreUserHasDuplicateIpModule,
    DatastoreUserRestrictionsModule,
    DatastoreUserRequiresPaymentVerificationModule,
    DatastoreUsersFollowModule,
    DatastoreUsersLocationModule,
    DatastoreUsersModule,
    DatastoreUsersRecommendModule,
    HireMeModule,
    MatTooltipModule,
    PipesModule,
    TrackingModule,
    UiModule,
  ],
  declarations: [
    UserProfileContactModalComponent,
    UserProfileContactModalHireMeFormComponent,
    UserProfileContactModalOptionsComponent,
    UserProfileRequestQuoteFormComponent,
  ],
})
export class UserProfileContactModalModule {}
